import * as React from "react";
import Lottie from "react-lottie";
const animationData = require("../assets/empty_box.json");

interface Props {
  message?: string;
}
export default class EmptyState extends React.Component<Props> {
  state = { isStopped: false, isPaused: false };

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          marginTop: 24
        }}
      >
        <Lottie
          options={defaultOptions}
          height={200}
          width={200}
          isStopped={this.state.isStopped}
          isPaused={this.state.isPaused}
        />
        <div style={{ textAlign: "center", marginTop: 16 }}>
          {this.props.message ? this.props.message : "There is no item"}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emptyState.tsx